import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { Link as Link$1 } from 'wouter';
import { PropTypes as PropTypes$1 } from '@panneau/core';
import Button from '@panneau/element-button';
import Label from '@panneau/element-label';

var styles = {"withoutStyle":"panneau-element-link-withoutStyle"};

var _excluded = ["external", "children", "target", "rel", "className", "withoutStyle", "href", "onClick"];
var propTypes = {
  href: PropTypes.string,
  external: PropTypes.bool,
  target: PropTypes.string,
  children: PropTypes$1.label,
  rel: PropTypes.string,
  withoutStyle: PropTypes.bool,
  className: PropTypes.string,
  onClick: PropTypes.func
};
var defaultProps = {
  href: '',
  external: false,
  target: '_blank',
  rel: 'noopener noreferrer',
  children: null,
  withoutStyle: false,
  className: null,
  onClick: null
};
var Link = function Link(_ref) {
  var external = _ref.external,
    children = _ref.children,
    target = _ref.target,
    rel = _ref.rel,
    className = _ref.className,
    withoutStyle = _ref.withoutStyle,
    href = _ref.href,
    onClick = _ref.onClick,
    props = _objectWithoutProperties(_ref, _excluded);
  var inner = href !== null ? /*#__PURE__*/React.createElement(Link$1, Object.assign({
    href: href,
    onClick: onClick,
    className: classNames([className, _defineProperty({}, styles.withoutStyle, withoutStyle)])
  }, props), /*#__PURE__*/React.createElement(Label, null, children)) : /*#__PURE__*/React.createElement(Button, Object.assign({
    className: classNames([className, _defineProperty({}, styles.withoutStyle, withoutStyle)]),
    theme: "primary",
    outline: true
  }, props, {
    onClick: onClick
  }), /*#__PURE__*/React.createElement(Label, null, children));
  return external ? /*#__PURE__*/React.createElement("a", Object.assign({
    className: classNames([className, _defineProperty({}, styles.withoutStyle, withoutStyle)]),
    target: target,
    rel: rel,
    href: href,
    onClick: onClick
  }, props), /*#__PURE__*/React.createElement(Label, null, children)) : inner;
};
Link.propTypes = propTypes;
Link.defaultProps = defaultProps;

export { Link as default };
